import { createSelector, Dictionary } from '@reduxjs/toolkit';
import GroupModel from '../api/GroupModel';
import { RootState } from '../../store.model';
import { RouterComponentProps } from '../../../util/route-dom';
import { GroupAPI } from '../api/GroupAPI';
import { isNotNullOrUndefined } from '../../../util/types/Array';
import { NormalizedGroup } from '../api/GroupAdapter';

export type RouterComponentPropsGroup = Pick<
  RouterComponentProps<{
    groupId?: string;
    merchandiserId?: string;
  }>,
  'params'
>;

export const getGroups = createSelector(
  [GroupAPI.endpoints.getGroups.select(undefined)],
  (groupsResponse) => {
    const groups =
      groupsResponse.data?.result
        .map((id) => groupsResponse.data?.entities.groups[id])
        .filter(isNotNullOrUndefined) || [];
    return groups;
  }
);

export const getGroupIds = (state: RootState) =>
  GroupAPI.endpoints.getGroups.select(undefined)(state).data?.result;
const emptyGroupsDictionary: Dictionary<NormalizedGroup> = {};
export const getDictionaryGroups = (state: RootState) =>
  GroupAPI.endpoints.getGroups.select(undefined)(state).data?.entities.groups ??
  emptyGroupsDictionary;
export const getGroupsLoading = (state: RootState) =>
  GroupAPI.endpoints.getGroups.select(undefined)(state).isLoading;

export const getAllGroups = createSelector(
  [GroupAPI.endpoints.getGroups.select(undefined)],
  (groupsResponse) => {
    const groups =
      Object.values(groupsResponse.data?.entities.groups || {}).filter(
        isNotNullOrUndefined
      ) || [];
    return groups;
  }
);
export const isGroupsLoading = (state: RootState) =>
  GroupAPI.endpoints.getGroups.select(undefined)(state).isLoading;
export const getDeviceIdFromProps = (
  _: RootState,
  props: { deviceId: string }
) => props.deviceId;

export const getGroupIdQueryParam = (
  _: RootState,
  props: RouterComponentPropsGroup
) => props.params.groupId || props.params.merchandiserId;
export const getGroupIdProps = (
  _: RootState,
  props: {
    groupId?: string;
  }
) => props.groupId;

export const getGroupsByDeviceIdByPropsSelector = createSelector(
  [getDeviceIdFromProps, getDictionaryGroups],
  (deviceId, groupsDictionary = {}) => {
    const groups = Object.values(groupsDictionary).filter((group) =>
      group?.devices?.includes(deviceId)
    );
    return groups;
  }
);

export const getGroupByGroupIdSelector = createSelector(
  [getGroupIdProps, GroupAPI.endpoints.getGroups.select(undefined)],
  (groupId, groupsDictionary) =>
    groupId ? groupsDictionary.data?.entities.groups[groupId] : undefined
);

export const getGroupSelectedByQueryParamSelector = createSelector(
  [getGroupIdQueryParam, GroupAPI.endpoints.getGroups.select(undefined)],
  (groupId, groupsDictionary) =>
    groupId ? groupsDictionary.data?.entities.groups[groupId] : undefined
);

export const getGroupsByGroupIdSelector = createSelector(
  [GroupAPI.endpoints.getGroups.select(undefined), getGroupByGroupIdSelector],
  (groupsResponse, group) => {
    const groups = group?.childGroups
      ?.map((id) => groupsResponse.data?.entities.groups[id])
      .filter(isNotNullOrUndefined);
    return groups;
  }
);

export const getAllDevicesIdsOnGroupsByGroupIdQueryParamSelector =
  createSelector(
    [getDictionaryGroups, () => undefined, getGroupIdQueryParam],
    GroupModel.getAllDevicesIdFromGroups
  );

export const getAllDevicesIdsOnGroupsByGroupIdPropSelector = createSelector(
  [getDictionaryGroups, () => undefined, getGroupIdProps],
  GroupModel.getAllDevicesIdFromGroups
);
